"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var INSTANCE;
var Log = (function () {
    function Log(parent, keys) {
        this.closed = false;
        this.keys = keys;
        this.parent = parent;
    }
    Log.getInstance = function () {
        if (INSTANCE == null) {
            throw new Error('No BBLog Instance created, run BBLog.createLogger first');
        }
        return INSTANCE;
    };
    Log.createLogger = function (obj) {
        INSTANCE = new Log(null, { name: obj.name, hostname: obj.hostname });
        if (obj.streams && Array.isArray(obj.streams)) {
            obj.streams.forEach(function (stream) { return INSTANCE.addStream(stream); });
        }
        if (obj.stream) {
            INSTANCE.addStream(obj.stream);
        }
        if (obj.keys) {
            INSTANCE.addKeys(obj.keys);
        }
        return INSTANCE;
    };
    Log.child = function (keys) {
        return Log.getInstance().child(keys);
    };
    Log.prototype.child = function (keys) {
        return new Log(this, keys);
    };
    Log.prototype.addStream = function (stream) {
        this.streams = this.streams || [];
        this.streams.push(stream);
        return this;
    };
    Log.prototype.addKeys = function (obj) {
        var _this = this;
        Object.keys(obj).forEach(function (key) {
            _this.keys[key] = obj[key];
        });
    };
    Log.prototype.close = function () {
        this.closed = true;
        var closeAllStreams = this.streams.map(function (s) { return s.close == null ? null : s.close(); });
        return Promise.all(closeAllStreams).then(function (_) { return null; });
    };
    Log.prototype.trace = function (data, msg) {
        this.log(Log.TRACE, data, msg);
    };
    Log.prototype.debug = function (data, msg) {
        this.log(Log.DEBUG, data, msg);
    };
    Log.prototype.info = function (data, msg) {
        this.log(Log.INFO, data, msg);
    };
    Log.prototype.warn = function (data, msg) {
        this.log(Log.WARN, data, msg);
    };
    Log.prototype.error = function (data, msg) {
        this.log(Log.ERROR, data, msg);
    };
    Log.prototype.fatal = function (data, msg) {
        this.log(Log.FATAL, data, msg);
    };
    Log.prototype.joinKeys = function (obj) {
        if (this.parent) {
            this.parent.joinKeys(obj);
        }
        var keys = this.keys;
        if (keys == null) {
            return obj;
        }
        Object.keys(keys).forEach(function (key) { return obj[key] = keys[key]; });
        return obj;
    };
    Log.prototype.log = function (level) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var output = {
            pid: 0,
            time: new Date(),
            hostname: '',
            level: level,
            msg: '',
            v: Log.LOG_VERSION
        };
        this.joinKeys(output);
        for (var i = 0; i < data.length; i++) {
            var dataValue = data[i];
            if (dataValue == null) {
                continue;
            }
            if (typeof dataValue === 'string') {
                output.msg = output.msg + dataValue;
            }
            else if (dataValue instanceof Error) {
                output.err = ErrorSerializer(dataValue);
            }
            else {
                Object.keys(dataValue).forEach(function (key) {
                    var value = dataValue[key];
                    if (value instanceof Error) {
                        output[key] = ErrorSerializer(value);
                    }
                    else {
                        output[key] = value;
                    }
                });
            }
        }
        this.write(output);
    };
    Log.prototype.write = function (message) {
        if (this.closed) {
            return;
        }
        if (this.streams && this.streams.length > 0) {
            for (var i = 0; i < this.streams.length; i++) {
                var obj = this.streams[i];
                obj.write(message);
            }
            return true;
        }
        if (this.parent) {
            return this.parent.write(message);
        }
    };
    return Log;
}());
Log.TRACE = 10;
Log.DEBUG = 20;
Log.INFO = 30;
Log.WARN = 40;
Log.ERROR = 50;
Log.FATAL = 60;
Log.LOG_VERSION = 0;
Log.LEVELS = {
    trace: Log.TRACE,
    debug: Log.DEBUG,
    info: Log.INFO,
    warn: Log.WARN,
    error: Log.ERROR,
    fatal: Log.FATAL
};
exports.Log = Log;
// Taken from Bunyan :  https://github.com/trentm/node-bunyan/blob/master/lib/bunyan.js
function getFullErrorStack(ex) {
    var ret = ex.stack || ex.toString();
    if (ex.cause && typeof (ex.cause) === 'function') {
        var cex = ex.cause();
        if (cex) {
            ret += '\nCaused by: ' + getFullErrorStack(cex);
        }
    }
    return (ret);
}
function ErrorSerializer(err) {
    if (!err || !err.stack) {
        return err;
    }
    return {
        message: err.message,
        name: err.name,
        stack: getFullErrorStack(err),
        code: err.code,
        signal: err.signal
    };
}
exports.ErrorSerializer = ErrorSerializer;
//# sourceMappingURL=log.js.map